import { combineReducers } from 'redux';
import { Action } from '@reduxjs/toolkit';

import advancedFilters from './advancedFilters';
import auth from './auth';
import collections from './collections';
import adjustments from './adjustments';
import invoices from './invoices';
import invoiceDisclosures from './invoiceDisclosures';
import { invoicesApi } from '../api/invoices';
import notifications from './notifications';
import onboarding from './onboarding';
import vendorAccount from './vendorAccount';
import vendor from './vendor';
import { vendorApi } from '../api/vendor';
import ui from './ui';
import payments from './payments';
import { paymentsApi } from '../api/payments';
import modals from './modals';
import { collectionsApi } from '../api/collections';
import { externalVendorsApi } from '../api/externalVendors';
import demoMode from './demoMode';
import selectedPartner from './selectedPartner';
import onboardingSidebar from './onboardingSidebar';

const reducer = combineReducers({
  advancedFilters,
  auth,
  collections,
  adjustments,
  demoMode,
  invoices,
  invoiceDisclosures,
  modals,
  notifications,
  onboarding,
  onboardingSidebar,
  payments,
  vendorAccount,
  vendor,
  ui,
  selectedPartner,
  [invoicesApi.reducerPath]: invoicesApi.reducer,
  [vendorApi.reducerPath]: vendorApi.reducer,
  [paymentsApi.reducerPath]: paymentsApi.reducer,
  [collectionsApi.reducerPath]: collectionsApi.reducer,
  [externalVendorsApi.reducerPath]: externalVendorsApi.reducer,
});

const reducerWithSignOut = (state: ReturnType<typeof reducer> | undefined, action: Action) => {
  if (action.type === 'SIGN_OUT') {
    return reducer(undefined, action);
  }

  if (action.type === 'RESET_VENDOR_STATE') {
    return reducer({ auth: state?.auth }, action);
  }

  return reducer(state, action);
}

export default reducerWithSignOut;
